'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMessageToThreadHistory = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _ifThen = require('transmute/ifThen');

var _ifThen2 = _interopRequireDefault(_ifThen);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _messageKeyInvariant = require('conversations-schema/invariants/messageKeyInvariant');

var _threadHistoryInvariant = require('conversations-schema/invariants/threadHistoryInvariant');

var _setMessage = require('conversations-schema/thread-history/operators/setMessage');

var _sortMessages = require('conversations-schema/thread-history/operators/sortMessages');

var _hasInitialMessagesToPublish = require('conversations-schema/thread-history/operators/hasInitialMessagesToPublish');

var _historyMessageInvariant = require('../invariants/historyMessageInvariant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Add a message to ThreadHistory and conditionally sort if the message is not
 * presentational.  Sorting can be skipped otherwise because the projection of
 * the history will not change.
 *
 * @param {string} messageKey
 * @param {PubNubMessageRecord} message
 * @param {ThreadHistory} threadHistory
 * @returns {ThreadHistory}
 */
var addMessageToThreadHistory = exports.addMessageToThreadHistory = (0, _curry2.default)(function (messageKey, message, threadHistory) {
  (0, _messageKeyInvariant.messageKeyInvariant)(messageKey);
  (0, _historyMessageInvariant.historyMessageInvariant)(message);
  (0, _threadHistoryInvariant.threadHistoryInvariant)(threadHistory);

  return (0, _pipe2.default)((0, _setMessage.setMessage)(messageKey, message), (0, _ifThen2.default)(function () {
    return !(0, _hasInitialMessagesToPublish.hasInitialMessagesToPublish)(threadHistory) && (0, _messageTypeComparators.isPresentationalMessage)(message);
  }, _sortMessages.sortMessages))(threadHistory);
});